<template>
  <div :class="(mode === 'Kitchen') ? 'dynamic-height' : ''">
    <!-- <div class="orderBox" v-for="order in orders" :key="order.id"> -->
      <template v-if="mode === 'Client'" class="orderBox">
        <div class="container">
          <div class="column" id="column1">
            <template v-for="order in orders">
              <div v-if="order.status.id == 'PROCESSING'" class="order-container status-1">
                <span class="order-number-size bold">#{{parseInt(order.number)}}</span>
                <!-- {{order.table_data.type}} -->
                <!-- <span v-if="order.table_data"> - {{order.table_data.number}}</span> -->
                <!-- <span v-else> - APP</span> -->
              </div>
            </template>
          </div>
          <div class="column" id="column2">
            <template v-for="order in orders">
              <div v-if="order.status.id == 'PREPARED'" class="order-container status-2">
                <span class="order-number-size bold">#{{parseInt(order.number)}}</span>
                <!-- <span v-if="order.table_data"> - {{order.table_data.number}}</span> -->
                <!-- <span v-else> - APP</span> -->
              </div>
            </template>
          </div>
        </div>
      </template>
      <template v-if="mode === 'Kitchen'">
        <div class="orderBox" v-for="order in orders" :key="order.id">
          <div class="orderBox__top">
            <div class="orderBox__details">
              <div class="detail">
                <span class="user margin-bot-2">{{order.delivery_details_firstname}} <span class="red-text">{{order.user_labeling}}</span></span>
                <span class="token red-text font-size-27 bold">#{{order.number}}</span>
              </div>
              <span @click="() => {window.open('tel:' + order.country_prefix + '' + order.delivery_details_phone, '_system')}" class="user margin-bot-2">Tel: {{order.country_prefix}}{{ order.delivery_details_phone }}</span>
              <span v-if="order.address_shipping" class="user margin-bot-2">{{lang.address}}: {{order.address_shipping.street}} {{order.address_shipping.number}} {{order.address_shipping.floor}} {{order.address_shipping.apartment}}</span>
              <span v-if="order.delivery_type == 'MEET_HALF' && order.delivery_details" class="user margin-bot-2">Point: {{order.delivery_details.location.name}}</span>
              <span v-if="order.order_from" class="user margin-bot-2">{{lang.orderFrom}}: {{order.order_from}}</span>
              <span v-if="order.pickup_datetime" class="user margin-bot-2 red-text">{{getDateAndHour(order.pickup_datetime)}}</span>
              <span v-if="order.location_name" class="user margin-bot-2">{{lang.location}}: {{order.location_name}}</span>
              <span v-if="order.comments" class="user margin-bot-2">- {{order.comments}}</span>

              <template v-if="order.billing_data">
              <br>
              <span class="user red-text margin-bot-2">{{lang.withInvoice}}::</span>
              <span class="user red-text margin-bot-2">- {{lang.company}}:: {{JSON.parse(order.billing_data,1)['name']}}</span>
              <span class="user red-text margin-bot-2">- {{lang.vat}}: {{JSON.parse(order.billing_data,1)['vatCode']}}</span>
              <span class="user red-text margin-bot-2">- {{lang.address}}: {{JSON.parse(order.billing_data,1)['address']}}
                <span v-if="JSON.parse(order.billing_data,1)['city']">{{JSON.parse(order.billing_data,1)['city']}}, </span>
                <span v-if="JSON.parse(order.billing_data,1)['county']">{{JSON.parse(order.billing_data,1)['county']}}, </span>
                <span v-if="JSON.parse(order.billing_data,1)['country']">{{JSON.parse(order.billing_data,1)['country']}}</span>
              </span>
              <br>
              </template>


              <template v-for="part in order.parts">
                <span v-if="order.order_type === 'GROUP'" class="user">{{part.customer_name}}</span>
                <template v-for="item in part.items">
                  <div class="detail">
                    <div class="leftt">
                      <span class="quantity">{{item.quantity}}X</span>
                      <span class="name">{{item.name}}</span>
                    </div>
                    <span class="price_total_product">{{item.price}} {{order.currency}}</span>
                  </div>
                  <div class="options" v-if="item.options.length">
                    <template v-for="option in item.options">
                      <div class="option">
                        <span>{{option.name}}</span>
                        <span>{{option.price}} {{order.currency}}</span>
                      </div>
                    </template>
                  </div>
                  <div v-if="item.additional_info" class="options">
                    <span class="comm">{{item.additional_info}}</span>
                  </div>
                </template>
              </template>
              <div class="subtotal" v-if="order.totals.shipping != '0.00' || order.totals_tip || order.totals.discount || order.totals.extras">
                <span><b>{{lang.subtotal}}:</b></span>
                <span>{{order.totals.subtotal}} {{order.currency}}</span>
              </div>
              <div class="dtt" v-if="order.totals.shipping != '0.00' || order.totals_tip || order.totals.discount">
                <div class="total_shipping" v-if="order.totals.shipping != '0.00'">
                  <span><b>{{lang.total_shipping}}:</b></span>
                  <span>{{order.totals.shipping}} {{order.currency}}</span>
                </div>
                <div class="totals_tip" v-if="order.totals_tip">
                  <span><b>{{lang.totals_tip}}:</b></span>
                  <span>{{order.totals_tip}} {{order.currency}}</span>
                </div>
                <div class="extras" v-if="order.totals.extras">
                  <span><b>{{lang.extras}}:</b></span>
                  <span>{{order.totals.extras}} {{order.currency}}</span>
                </div>
                <div class="discount" v-if="order.totals.discount">
                  <span><b>{{lang.discount}}:</b></span>
                  <span>{{order.totals.discount}} {{order.currency}}</span>
                </div>
              </div>
              <div class="grandTotal">
                <span><b>{{lang.total}}:</b></span>
                <span>{{order.totals_grandtotal}} {{order.currency}}</span>
              </div>
            </div>
            <div class="orderBox__products">
              <div class="orderBox__time" :class="order.status.id">
                <span>{{getHour(order.pickup_datetime)}}</span>
              </div>
              <div class="orderBox__data">
                <!-- <span class="name">{{order.delivery_details_firstname}}</span> -->
                <span class="token">#{{order.token}}</span>
                <span v-if="order.delivery_type === 'DELIVERY' && order.tazz_laas_flag && order.tazz_laas_status !== 0">
                  <span class="delivery_type call_driver" @click="openTazzCourierModal(order.id)" v-if="(order.tazz_laas_status === 1 || order.tazz_laas_status === 3 || order.tazz_laas_status === 4) && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')">Tazz</span>
                  <span class="delivery_type cancel_driver" @click="openTazzCourierCancelModal(order.id)" v-if="order.tazz_laas_status === 2 && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')">Tazz</span>
                </span>

                <span v-if="order.delivery_type === 'DELIVERY' && order.glovo_flag">
                  <span class="delivery_type call_driver" @click="openGlovoCourierModal(order.id)" v-if="(order.glovo_status === 1 || order.glovo_status === 3 || order.glovo_status === 4) && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')">Glovo</span>
                  <span class="delivery_type cancel_driver" @click="openGlovoCourierCancelModal(order.id)" v-if="order.glovo_status === 2 && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')">Glovo</span>
                </span>

                <span v-if="order.delivery_type === 'DELIVERY' && order.wolt_drive_flag">
                  <span class="delivery_type call_driver" @click="openWoltCourierModal(order.id)" v-if="(order.wolt_drive_status === 1 || order.wolt_drive_status === 3 || order.wolt_drive_status === 4) && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')">Wolt Drive</span>
                  <span class="delivery_type cancel_driver" @click="openWoltCourierCancelModal(order.id)" v-if="order.wolt_drive_status === 2 && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')">Wolt Drive</span>
                </span>

                <span v-if="order.delivery_type === 'DELIVERY' && order.boogit_flag && order.boogit_status !== 0">
                  <span class="delivery_type call_driver" @click="callBoogItCourier(order.id)" v-if="(order.boogit_status === 1 || order.boogit_status === 3 || order.boogit_status === 4) && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')">BoogIt</span>
                  <span class="delivery_type cancel_driver" @click="openCancelBoogitCourierModal(order.id)" v-if="order.boogit_status === 2 && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')">BoogIt</span>
                </span>

                <span v-if="order.delivery_type === 'DELIVERY' && order.packageez_flag">
                  <span class="delivery_type call_driver" @click="callPackageezCourier(order.id)" v-if="!isPackageezCourierCalled(order) && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')">Packageez</span>
                  <span class="delivery_type cancel_driver" @click="openCancelPackageezCourierModal(order.id)" v-if="isPackageezCourierCalled(order) && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')">Packageez</span>
                  <span class="delivery_type cancel_driver" style="opacity: 0.5; cursor: not-allowed; pointer-events: none;" v-if="order.status.id === 'TRANSPORT' || order.status.id === 'CANCELED' || order.status.id === 'NOT_DELIVERED'">Packageez</span>
                </span>

                <span class="delivery_type" @click="printOrderReceipt(order)">{{lang.print}}</span>
                <span class="delivery_type call_driver" @click="callDriver(order.id)" v-if="order.delivery_type == 'DELIVERY' && order.dr_carmen_status == 0 && order.dr_carmen_active == 1">{{lang.drCarmen}}</span>
                <span class="delivery_type cancel_driver" @click="cancelDriver(order.id)" v-if="order.delivery_type == 'DELIVERY' && order.dr_carmen_status != 0 && order.dr_carmen_active == 1">{{lang.drCarmen}}</span>
                <span class="delivery_type">{{lang.delivery_type[order.delivery_type]}}</span>
                <span :class="order.isPaidOnline ? `ONLINE payment_type` : `${order.payment_type} payment_type`">{{ lang.payment_type[order.payment_type] }}</span>
              </div>
            </div>
          </div>
          <template v-if="order.status.id == 'NEW' || 
                          order.status.id == 'PROCESSING' || 
                          order.status.id == 'PREPARED' || 
                          order.status.id == 'TRANSPORT'">
            <div class="orderBox__bottom" v-if="order_statuses">
              <template v-for="(status, k) in order_statuses[order.delivery.id]"> 
                <template v-if="k != 'NEW' && k != 'DRAFT' && k != 'NOT_DELIVERED' && k != 'ON_HOLD' && k != 'OPEN_DRAFT' && k != 'POSTPONED'">
                  <button @click="changeStatus(order, k)" :class="(order.status.id == k)? k+' active':k" :disabled="checkStatusIfDesabled(order.status.id, k)">{{lang.statuses[k]}}</button>
                </template>
              </template>
            </div>
          </template>
          <template v-else>
            <div class="orderBox__bottomRez">
              <span>{{order.status.id}}</span>
            </div>
          </template>
        </div>
      </template>
    <!-- </div> -->
    <modal name="modalTimeStatus">
      <div class="modalContainer">
        <!-- <div :class="(!debouncePrinFiscal ? 'show-loader' : 'hide-loader')">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div> -->
        <div class="title">
          <!-- <h2>{{ lang.orderPickupDatetime }}: {{//showPickupDatetime(modalOrderId)}}</h2> -->
          <h2 v-if="modalOrder && modalOrder.pickup_datetime">{{ lang.orderPickupDatetime }}: {{getHour(modalOrder.pickup_datetime)}}</h2>
          <!-- <p>{{ lang.addMoreTime }}</p> -->
        </div>
        <h4>{{ lang.addExtra }}:</h4>
        <div class="addTimeBtnsContainer">
          <button @click="addTime(5)">+5{{ lang.minutes }}</button>
          <button @click="addTime(10)">+10{{ lang.minutes }}</button>
          <button @click="addTime(15)">+15{{ lang.minutes }}</button>
          <button @click="addTime(20)">+20{{ lang.minutes }}</button>
          <button @click="addTime(25)">+25{{ lang.minutes }}</button>
        </div>
        <div class="addTimeBtnsContainer">
          <button @click="addTime(30)">+30{{ lang.minutes }}</button>
          <button @click="addTime(45)">+45{{ lang.minutes }}</button>
          <button @click="addTime(60)">+60{{ lang.minutes }}</button>
          <button @click="addTime(120)">+120{{ lang.minutes }}</button>
          <button @click="addTime(150)">+150{{ lang.minutes }}</button>
        </div>
        <br>
        <div class="addTimeBtnsContainer">
          <button @click="addTime(-5)">-5{{ lang.minutes }}</button>
          <button @click="addTime(-10)">-10{{ lang.minutes }}</button>
          <button @click="addTime(-15)">-15{{ lang.minutes }}</button>
          <button @click="addTime(-20)">-20{{ lang.minutes }}</button>
          <button @click="addTime(-25)">-25{{ lang.minutes }}</button>
        </div>
        <div class="addTimeBtnsContainer">
          <button @click="addTime(-30)">-30{{ lang.minutes }}</button>
          <button @click="addTime(-45)">-45{{ lang.minutes }}</button>
          <button @click="addTime(-60)">-60{{ lang.minutes }}</button>
          <button @click="addTime(-120)">+120{{ lang.minutes }}</button>
          <button @click="addTime(-150)">+150{{ lang.minutes }}</button>
        </div>
        <br>
        <br>
        <button class="width25" @click="addTime(0)">{{ lang.done }}</button>
      </div>
    </modal>
    <modal name="callDriverModel">
      <div class="modalContainer">
        <div class="title">
          <h2>{{ lang.packageCount }}</h2>
          <!-- <p>{{ lang.addMoreTime }}</p> -->
        </div>
        <div class="addTimeBtnsContainer">
          <input class="input-font-size" type="text" v-model="packages" v-on:keyup.enter="confirmCallDriver">
        </div>
        <br>
        <br>
        <button class="width25" @click="cancelCallDriver()">{{ lang.cancel }}</button>
        <button class="width25" @click="confirmCallDriver()">{{ lang.callDriver }}</button>
      </div>
    </modal>
    <modal name="glovoModal">
      <div class="modalContainer">
        <div class="title">
          <h2>{{lang.courierTime}}</h2>
        </div>
        <div class="addTimeBtnsContainer" style="margin-bottom: 50px">
          <button @click="callGlovoCourier(1)">{{lang.now}}</button>
          <button @click="callGlovoCourier(15)">15{{ lang.minutes }}</button>
          <button @click="callGlovoCourier(30)">30{{ lang.minutes }}</button>
          <button @click="callGlovoCourier(60)">60{{ lang.minutes }}</button>
        </div>
        <br>
        <br>
        <button class="width25" @click="() => {this.$modal.hide('glovoModal');}">{{ lang.cancel }}</button>
      </div>
    </modal>
    <modal name="woltModal">
      <div class="modalContainer">
        <div class="title">
          <h2>{{lang.courierTime}}</h2>
        </div>
        <div class="addTimeBtnsContainer" style="margin-bottom: 50px">
          <button @click="callWoltCourier(1)">{{lang.now}}</button>
          <button @click="callWoltCourier(15)">15{{ lang.minutes }}</button>
          <button @click="callWoltCourier(30)">30{{ lang.minutes }}</button>
          <button @click="callWoltCourier(60)">60{{ lang.minutes }}</button>
        </div>
        <br>
        <br>
        <button class="width25" @click="() => {this.$modal.hide('woltModal');}">{{ lang.cancel }}</button>
      </div>
    </modal>
    <modal name="cancelGlovoModal">
      <div class="modalContainer">
        <div class="title">
          <h2>{{lang.callCourierCancel}}</h2>
        </div>
        <br>
        <br>
        <button class="width25" @click="cancelGlovoCourier()">{{lang.yes}}</button>
        <button class="width25" @click="() => {this.$modal.hide('cancelGlovoModal');}">{{lang.no}}</button>
      </div>
    </modal>
    <modal name="cancelWoltModal">
      <div class="modalContainer">
        <div class="title">
          <h2>{{lang.callCourierCancel}}</h2>
        </div>
        <br>
        <br>
        <button class="width25" @click="cancelWoltCourier()">{{lang.yes}}</button>
        <button class="width25" @click="() => {this.$modal.hide('cancelWoltModal');}">{{lang.no}}</button>
      </div>
    </modal>
    <modal name="glovoModalSuccess">
      <div class="modalContainer">
        <div class="title">
          <h2>{{lang.succes}}</h2>
        </div>
        <br>
        <br>
        <button class="width25" @click="() => {this.$modal.hide('glovoModalSuccess');}">Ok</button>
      </div>
    </modal>
    <modal name="glovoModalError">
      <div class="modalContainer">
        <div class="title">
          <h2 v-if="!glovoError">{{lang.error}}</h2>
          <h2>{{glovoError}}</h2>
        </div>
        <br>
        <br>
        <button class="width25" @click="() => {this.$modal.hide('glovoModalError'); this.glovoError = ''}">Ok</button>
      </div>
    </modal>
    <modal name="cancelBoogItModal">
      <div class="modalContainer">
        <div class="title">
          <h2>{{lang.callCourierCancel}}</h2>
        </div>
        <br>
        <br>
        <button class="width25" @click="cancelBoogItCourier()">{{lang.yes}}</button>
        <button class="width25" @click="() => {this.$modal.hide('cancelBoogItModal');}">{{lang.no}}</button>
      </div>
    </modal>
    <modal name="packageezModal">
      <div class="modalContainer">
        <div class="title">
          <h2>{{lang.packageDetails || 'Package Details'}}</h2>
        </div>
        <div class="addTimeBtnsContainer">
          <label style="display: block; margin-bottom: 5px;">{{lang.packageSize || 'Package Size'}}</label>
          <select v-model="packageezSize" class="input-font-size" style="margin-bottom: 15px;">
            <option value="30x30x10">30x30x10</option>
            <option value="30x30x20">30x30x20</option>
            <option value="30x30x30">30x30x30</option>
            <option value="60x60x30">60x60x30</option>
          </select>
        </div>
        <div class="addTimeBtnsContainer" style="margin-bottom: 10px">
          <label style="display: block; margin-bottom: 5px;">{{lang.courierTime}}</label>
          <select v-model="packageezTime" class="input-font-size">
            <option value="1">{{lang.now}}</option>
            <option value="15">15 {{lang.minutes}}</option>
            <option value="30">30 {{lang.minutes}}</option>
            <option value="45">45 {{lang.minutes}}</option>
            <option value="60">60 {{lang.minutes}}</option>
          </select>
        </div>
        <br>
        <br>
        <button class="width25" @click="() => {this.$modal.hide('packageezModal');}">{{ lang.cancel }}</button>
        <button class="width25" @click="confirmPackageezCourier()">{{lang.callDriver}}</button>
      </div>
    </modal>
    <modal name="cancelPackageezModal">
      <div class="modalContainer">
        <div class="title">
          <h2>{{lang.callCourierCancel}}</h2>
        </div>
        <br>
        <br>
        <button class="width25" @click="cancelPackageezCourier()">{{lang.yes}}</button>
        <button class="width25" @click="() => {this.$modal.hide('cancelPackageezModal');}">{{lang.no}}</button>
      </div>
    </modal>
    <modal name="tazzModal">
      <div class="modalContainer">
        <div class="title">
          <h2>{{lang.courierTime}}</h2>
        </div>
        <div class="addTimeBtnsContainer" style="margin-bottom: 50px">
          <button @click="callTazzCourier(1)">{{lang.now}}</button>
          <button @click="callTazzCourier(15)">15{{ lang.minutes }}</button>
          <button @click="callTazzCourier(30)">30{{ lang.minutes }}</button>
          <button @click="callTazzCourier(60)">60{{ lang.minutes }}</button>
        </div>
        <br>
        <br>
        <button class="width25" @click="() => {this.$modal.hide('tazzModal');}">{{ lang.cancel }}</button>
      </div>
    </modal>
    <modal name="cancelTazzModal">
      <div class="modalContainer">
        <div class="title">
          <h2>{{lang.callCourierCancel}}</h2>
        </div>
        <br>
        <br>
        <button class="width25" @click="cancelTazzCourier()">{{lang.yes}}</button>
        <button class="width25" @click="() => {this.$modal.hide('cancelTazzModal');}">{{lang.no}}</button>
      </div>
    </modal>
    <modal name="tazzModalSuccess">
      <div class="modalContainer">
        <div class="title">
          <h2>{{lang.succes}}</h2>
        </div>
        <br>
        <br>
        <button class="width25" @click="() => {this.$modal.hide('tazzModalSuccess');}">Ok</button>
      </div>
    </modal>
    <modal name="tazzModalError">
      <div class="modalContainer">
        <div class="title">
          <h2 v-if="!tazzError">{{lang.error}}</h2>
          <h2>{{tazzError}}</h2>
        </div>
        <br>
        <br>
        <button class="width25" @click="() => {this.$modal.hide('tazzModalError'); this.tazzError = ''}">Ok</button>
      </div>
    </modal>
    <modal name="cancelOrderModal">
      <div class="modalContainer">
        <div class="title">
          <h2>{{lang.cancelOrderConfirm}}</h2>
        </div>
        <br>
        <br>
        <button class="width25" @click="confirmCancelOrder()">{{lang.yes}}</button>
        <button class="width25" @click="() => {this.$modal.hide('cancelOrderModal'); this.debounceChangeStatus = 1;}">{{lang.no}}</button>
      </div>
    </modal>
    <modal name="refundModal">
      <div class="modalContainer">
        <div class="title">
          <h2>{{lang.automatRefund}}</h2>
        </div>
        <br>
        <br>
        <button class="width25" @click="automatRefund()">{{lang.yes}}</button>
        <button class="width25" @click="() => {this.$modal.hide('refundModal');}">{{lang.no}}</button>
      </div>
    </modal>
    <modal name="refundModalSuccess">
      <div class="modalContainer">
        <div class="title">
          <h2>{{lang.succes}}</h2>
        </div>
        <br>
        <br>
        <button class="width25" @click="() => {this.$modal.hide('refundModalSuccess');}">Ok</button>
      </div>
    </modal>
    <modal name="refundModalError">
      <div class="modalContainer">
        <div class="title">
          <h2>{{lang.automatRefundError}}</h2>
        </div>
        <br>
        <br>
        <button class="width25" @click="() => {this.$modal.hide('refundModalError');}">Ok</button>
      </div>
    </modal>
  </div>
</template>

<script>
  const axios = require('axios')
  export default {
    props: {
      orders: Array,
      order_statuses: Object,
      lang: Object,
      use_fiscal_net: Boolean,
      fiscal_ip: String,
      mode: String
    },
    data() {
      return {
        // ordersNew: [],
        debouncePrinFiscal: 1,
        debounceChangeStatus: 1,
        modalTimeStatus: false,
        callDriverForOrder: 0,
        modalOrder: null,
        packages: '',
        glovoError: '',
        tazzError: '',
        packageezSize: '30x30x10',
        packageezTime: '1',
        pendingCancelOrder: null,
        pendingCancelStatus: null,
        pendingCancelAddPickupTime: 0
      }
    },
    created() {
    },
    methods: {
      automatRefund() {
        this.$modal.hide('refundModal');
        let token = this.generateToken(this.modalOrder);
        
        let data = {
          screenToken: localStorage.getItem('screen'),
          token: token
        };
        this.apiRequest('noauth/automat-refund', 'POST', data, (response) => {
          if (response.status) {
            this.$modal.show('refundModalSuccess');
          } else {
            this.$modal.show('refundModalError');
          }
        });
      },
      generateToken (order) {
        const timestamp = new Date().getTime();

        let jsonOrderId = {
          id: order.id
        };

        let jsonCompanyId = {
          id: order.company_id
        };

        let jsonScreen = {
          hash: localStorage.getItem('screen')
        };

        const base64jsonOrderId = btoa(JSON.stringify(jsonOrderId));
        const base64jsonCompanyId = btoa(JSON.stringify(jsonCompanyId));
        const base64jsonScreen = btoa(JSON.stringify(jsonScreen));

        const token = btoa(
          `${Math.floor(Math.random() * 10)}${base64jsonOrderId}${Math.floor(Math.random() * 90) + 10}#${Math.floor(Math.random() * 10)}${base64jsonCompanyId}${Math.floor(Math.random() * 90) + 10}#${Math.floor(Math.random() * 10)}${base64jsonScreen}${Math.floor(Math.random() * 90) + 10}#${timestamp}${Math.floor(Math.random() * 10)}`
        );

        return token;
      },
      openWoltCourierModal (id) {
        this.orderId = id
        this.$modal.show('woltModal');
      },
      openWoltCourierCancelModal (id) {
        this.orderId = id
        this.$modal.show('cancelWoltModal');
      },
      openGlovoCourierModal (id) {
        this.orderId = id
        this.$modal.show('glovoModal');
      },
      openGlovoCourierCancelModal (id) {
        this.orderId = id
        this.$modal.show('cancelGlovoModal');
      },
      openTazzCourierModal (id) {
        this.orderId = id
        this.$modal.show('tazzModal');
      },
      openTazzCourierCancelModal (id) {
        this.orderId = id
        this.$modal.show('cancelTazzModal');
      },
      callWoltCourier(time) {
        this.$modal.hide('woltModal');
        let data = {
          id: this.orderId,
          time: time
        };
        this.apiRequest('/noauth/wolt-drive/create/' + this.orderId, 'POST', data, (response) => {
          if (response.status) {
            this.$modal.show('glovoModalSuccess');
          } else {
            this.glovoError = this.lang[response.errors] || this.lang.error;
            this.$modal.show('glovoModalError');
          }
        });
      },
      cancelWoltCourier () {
        this.$modal.hide('cancelWoltModal');
        this.apiRequest('/noauth/wolt-drive/cancel/' + this.orderId, 'POST', null, (response) => {
          if (response.status) {
            this.$modal.show('glovoModalSuccess');
          } else {
            this.glovoError = this.lang[response.errors] || this.lang.error;
            this.$modal.show('glovoModalError');
          }
        });
      },
      callGlovoCourier(time) {
        this.$modal.hide('glovoModal');
        let data = {
          id: this.orderId,
          time: time
        };
        this.apiRequest('noauth/glovo/create/' + this.orderId, 'POST', data, (response) => {
          if (response.status) {
            this.$modal.show('glovoModalSuccess');
          } else {
            this.glovoError = this.lang[response.errors]
            this.$modal.show('glovoModalError');
          }
        });
      },
      cancelGlovoCourier () {
        this.$modal.hide('cancelGlovoModal');
        this.apiRequest('noauth/glovo/cancel/' + this.orderId, 'POST', null, (response) => {
          if (response.status) {
            this.$modal.show('glovoModalSuccess');
          } else {
            this.glovoError = this.lang[response.errors]
            this.$modal.show('glovoModalError');
          }
        });
      },
      callBoogItCourier(orderId) {
        let data = {
          id: orderId
        };
        this.apiRequest('noauth/boogit/send-order/' + orderId, 'POST', data, (response) => {
          if (response.status) {
            this.$modal.show('glovoModalSuccess');
          } else {
            this.glovoError = this.lang[response.errors]
            this.$modal.show('glovoModalError');
          }
        });
      },
      openCancelBoogitCourierModal(id) {
        this.orderId = id
        this.$modal.show('cancelBoogItModal');
      },
      cancelBoogItCourier () {
        this.$modal.hide('cancelBoogItModal');
        this.apiRequest('noauth/boogit/cancel-order/' + this.orderId, 'POST', [], (response) => {
          if (response.status) {
            this.$modal.show('glovoModalSuccess');
          } else {
            this.glovoError = this.lang['error']
            this.$modal.show('glovoModalError');
          }
        });
      },
      isPackageezCourierCalled(order) {
        return !!order.packagez_order_id;
      },
      callPackageezCourier(orderId) {
        this.orderId = orderId;
        // Reset to default values
        this.packageezSize = '30x30x10';
        this.packageezTime = '1';
        this.$modal.show('packageezModal');
      },
      confirmPackageezCourier() {
        this.$modal.hide('packageezModal');
        const order = this.orders.find(o => o.id === this.orderId);
        let data = {
          id: this.orderId,
          location_id: order.store_id,
          company_id: order.company_id,
          size: this.packageezSize,
          time: this.packageezTime
        };

        this.apiRequest('noauth/packagez-send-order', 'POST', data, (response) => {
          if (response.status) {
            this.$modal.show('glovoModalSuccess');
          } else {
            this.glovoError = this.lang[response.errors] || this.lang.error;
            this.$modal.show('glovoModalError');
          }
        });
      },
      openCancelPackageezCourierModal(id) {
        this.orderId = id
        this.$modal.show('cancelPackageezModal');
      },
      cancelPackageezCourier () {
        this.$modal.hide('cancelPackageezModal');
        const order = this.orders.find(o => o.id === this.orderId);
        let data = {
          id: this.orderId,
          location_id: order.store_id,
          company_id: order.company_id,
          size: this.packageezSize,
          time: this.packageezTime
        };
        this.apiRequest('noauth/packagez-cancel-order', 'POST', data, (response) => {
          if (response.status) {
            this.$modal.show('glovoModalSuccess');
          } else {
            this.glovoError = this.lang['error']
            this.$modal.show('glovoModalError');
          }
        });
      },
      callTazzCourier(time) {
        this.$modal.hide('tazzModal');
        let data = {
          id: this.orderId,
          time: time
        };
        this.apiRequest('/noauth/tazz-laas/create/' + this.orderId + '/' + time, 'POST', data, (response) => {
          if (response.status) {
            this.$modal.show('tazzModalSuccess');
          } else {
            this.tazzError = response.errors
            this.$modal.show('tazzModalError');
          }
        });
      },
      cancelTazzCourier () {
        this.$modal.hide('cancelTazzModal');
        this.apiRequest('/noauth/tazz-laas/cancel/' + this.orderId, 'POST', null, (response) => {
          if (response.status) {
            this.$modal.show('tazzModalSuccess');
          } else {
            this.tazzError = response.errors
            this.$modal.show('tazzModalError');
          }
        });
      },
      // showPickupDatetime(orderid) {
      //   var order = 0;
      //   order = this.orders.find( ({ id }) => id === orderid );
      //   if (order) {
      //     return this.getHour(order.pickup_datetime);
      //   }else {
      //     return "";
      //   }
      // },
      addTime(min) {
        this.modalTimeStatus = true;
        this.$modal.hide('modalTimeStatus');
        this.changeStatus(this.modalOrder, 'PROCESSING', min);
        // if (this.use_fiscal_net) {
        //   if (this.debouncePrinFiscal) {
        //     this.debouncePrinFiscal = 0
        //     this.printFiscalNetAndFinish(this.modalOrder, () => {
        //       this.modalTimeStatus = true;
        //       this.$modal.hide('modalTimeStatus');
        //       this.changeStatus(this.modalOrder, 'PROCESSING', min);
        //       this.debouncePrinFiscal = 1
        //     })
        //   }
        // } else {
        //   this.modalTimeStatus = true;
        //   this.$modal.hide('modalTimeStatus');
        //   this.changeStatus(this.modalOrder, 'PROCESSING', min);
        // }
      },
      printOrderReceipt(order) {
        let url = process.env.VUE_APP_API_URL + 'noauth/print-order-receipt/';
        url += order.id;
        this.callUrl(url, (response) => {
          if (response.status) {
            order.print = response.data.data.print_text
            order.print_qr = response.data.data.print_qr
            this.postMessageToParent(order)
          }
        });
      },
      changeStatus(order, newStatus, addPickupTime = 0) {
        this.modalOrder = order;
        if (this.debounceChangeStatus) {
          this.debounceChangeStatus = 0;
          if (newStatus == 'PROCESSING') {
            if (!this.modalTimeStatus) {
              this.$modal.show('modalTimeStatus');
              this.modalTimeStatus = false;
              this.debounceChangeStatus = 1;
              return 0;
            }
          }
          if (newStatus == 'CANCELED') {
            // Store the order and status for confirmation
            this.pendingCancelOrder = order;
            this.pendingCancelStatus = newStatus;
            this.pendingCancelAddPickupTime = addPickupTime;
            this.$modal.show('cancelOrderModal');
            return 0;
          }
          if (newStatus == 'PREPARED' && this.use_fiscal_net) {
            this.printFiscalNetAndFinish(order, () => {
              this.callChangeStatus(order, newStatus, addPickupTime)
            })
          } else {
            this.callChangeStatus(order, newStatus, addPickupTime)
          }
          this.modalTimeStatus = false;
        }
      },
      confirmCancelOrder() {
        this.$modal.hide('cancelOrderModal');
        if (this.pendingCancelOrder && this.pendingCancelStatus) {
          const order = this.pendingCancelOrder;
          const newStatus = this.pendingCancelStatus;
          const addPickupTime = this.pendingCancelAddPickupTime;
          
          // Reset pending values
          this.pendingCancelOrder = null;
          this.pendingCancelStatus = null;
          this.pendingCancelAddPickupTime = 0;
          
          // Proceed with cancellation
          this.callChangeStatus(order, newStatus, addPickupTime)
        }
      },
      callChangeStatus(order, newStatus, addPickupTime) {
        let token = this.generateToken(order);

        let url = process.env.VUE_APP_API_URL + 'noauth/status?';
        url += "&orderid=" + order.id;
        url += "&status=" + newStatus;
        url += "&addPickupTime=" + addPickupTime;
        url += "&screenToken=" + localStorage.getItem('screen');
        url += "&token=" + token;

        this.callUrl(url, (res) => {
          this.debounceChangeStatus = 1;
          this.$emit('statusChanged', {});
          if (res && res.data && res.data.status && newStatus != 'PROCESSING') {
            this.$emit('deleteFromOrders', order.id);
          }
          if (newStatus == 'CANCELED' && order.payment_type == "CARD") {
            this.$modal.show('refundModal');
            this.modalOrder = order;
            this.debounceChangeStatus = 1;
            return 0;
          }
        });
      },
      printFiscalNetAndFinish (modalOrder, callback) {
        let url = process.env.VUE_APP_API_URL + 'noauth/print-fiscal-net/' + modalOrder.id + '/0'; //KioskId = 0 if notKiosk
        // url += "&cui=" + cui;  // cui pe bod

        // Tipuri de plata: 1=Numerar, 2=Card, 3=Credit, 4=Tichet masa, 5=Tichet valoric, 6=Voucher, 7=Plata moderna, 8=Alte modalitati, 9=Alte modalitati
        let pay_method = 1;
        if (modalOrder.payment_type == 'CARD') {
          pay_method = 2;
        }
        url += "&pay_method=" + pay_method;
        
        this.callUrl(url, (response) => {
          if (response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
            axios.post('http://' + this.fiscal_ip + ':65400/api/Receipt', '[\n' + response.data.data + '\n]')
            .then(
              (response) => {
                // console.log(response.data)
                if (response.data && response.data.ReceiptStatus) {
                  callback()
                } else {
                  alert('Error FiscalNet')
                  // this.debouncePrinFiscal = 1
                  this.debounceChangeStatus = 1;
                }
              }
            ).catch(err => {
              // console.log(err)
              alert('FiscalNet Error')
              // this.debouncePrinFiscal = 1
              this.debounceChangeStatus = 1;
            })
          } else {
            // this.debouncePrinFiscal = 1
            this.debounceChangeStatus = 1;
          }
        });
      },
      callDriver(orderid) {
        this.callDriverForOrder = orderid
        this.packages = ''
        this.$modal.show('callDriverModel');
      },
      cancelCallDriver() {
        this.$modal.hide('callDriverModel');
      },
      confirmCallDriver() {
        // console.log(this.packages)
        // console.log('weeeeeeeeee callll driver for' + this.callDriverForOrder + ' and packages = ' + this.packages)
        let url = process.env.VUE_APP_GENERAL_API_URL + 'noauth/screen/call-drcarmen/'+this.callDriverForOrder+'/'+ this.packages
        this.callUrl(url, (res) => {
        });
        this.$modal.hide('callDriverModel');
      },
      cancelDriver(orderid) {
        let url = process.env.VUE_APP_GENERAL_API_URL + 'noauth/screen/cancel-drcarmen/'+orderid
        this.callUrl(url, (res) => {
        });
      },
      checkStatusIfDesabled(status, btn) {
        // console.log(status);
        // console.log(btn);
        // console.log("____");

        if (status == 'NEW') {
          if (btn == 'PROCESSING' || btn == 'CANCELED') {
            return false;
          } else {
            return true;
          }
        }

        if (status == 'CANCELED' || status == 'DELIVERED') {
          return true;
        }
        if (btn == 'PROCESSING' && status != 'NEW') {
          return true;
        }
        // if (btn == 'TRANSPORT') {
        //   return true;
        // }
        if (status === btn) {
          return true;
        }
        return false;
      },
      getHour(val) {
        let date = new Date(val);
        let hours = date.getHours();
        let minutes = date.getMinutes();
        hours = hours < 10 ? "0" + hours : hours;
        minutes = minutes < 10 ? "0" + minutes : minutes;
        return hours + ":" + minutes;
      },
      getDateAndHour(val) {
        let date = new Date(val);
        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();
        day = day < 10 ? "0" + day : day;
        month = month < 10 ? "0" + month : month;

        let time = this.getHour(val);

        return `${day}/${month}/${year} ${time}`;
      },
      callUrl: function(url, callback) {
        axios
          .get(url)
          .then(function (response) {
            callback(response);
          })
          .catch(function (error) {
            callback(0);
          })
      },
      postUrl: function(url, callback) {
        axios
          .post(url)
          .then(function (response) {
            callback(response);
          })
          .catch(function (error) {
            callback(0);
          })
      }
    }
  }
</script>


<style scoped lang="scss">
  .red-text {
    color: red;
  }

  .bold {
    font-weight: bold;
  }

  .font-size-27 {
    font-size: 27px;
  }
  
  .addTimeBtnsContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 20px;
    padding-top: 0;
    button {
      margin: 4px;
      border: 0;
    }
  }
  .orderBox {
    display: flex; 
    flex-direction: column;
    margin: 10px;
    width: calc(100% - 20px);
    @media screen and (min-width: 900px) {
      width: calc(50% - 20px);
      display: inline-block;
    }
    @media screen and (min-width: 1300px) {
      width: calc(33.33% - 30px);
      display: inline-block;
    }
    @media screen and (min-width: 1700px) {
      width: calc(25% - 40px);
      display: inline-block;
    }
    .orderBox__top {
      display: flex;
      border: 1px solid #333;
      border-bottom: 0px;
      height: calc(100% - 39px);
      .orderBox__details {
        width: 70%;
        display: flex;
        flex-direction: column;
        // align-items: baseline;
        align-items: flex-end;
        padding: 10px;
        .user {
          font-weight: 700;
          width: 100%;
          text-align: left;
        }
        .detail {
          display: flex;
          align-items: center;
          justify-content: space-between;
          span {
            display: table-cell;
          }
          .leftt {
            width: 70%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
          }
          .quantity {
            text-align: left;
            min-width: 25px;
          }
          .name {
            text-align: left;
          }
          .price_total_product {
            text-align: right;
          }
          width: 100%;
          // display: flex;
          // align-items: center;
          // justify-content: space-between;
        }
      }
      .orderBox__products {
        width: 30%;
        display: flex;
        flex-direction: column;
        .orderBox__time {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 10px;
          font-size: 2em;
          color: #fff;
        }
        .orderBox__data {
          padding-top: 10px;
          padding-bottom: 10px;
          .delivery_type,
          .token {
            display: block;
            margin-bottom: 5px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .delivery_type {
            background: #333333;
            color: #fff;
            padding: 5px;
            font-weight: 700;
            display: block;
            margin-bottom: 5px;
            &.call_driver {
              background: #0a840f;
            }
            &.cancel_driver {
              background: #eb5e28;
            }
          }
          .payment_type {
            color: #fff;
            padding: 5px;
            font-weight: 700;
            display: block;
            margin-bottom: 5px;
            background: #0a840f;
            &.CASH {
              background: #0a840f;
            }
            &.CARD {
              background: #0a1f84;
            }
            &.ONLINE {
              background: #cf9529;
            }
            &.POS {
              background: #8BC34A;
            }
          }
        }
      }
    }
    .orderBox__bottom {
      display: flex;
      width: 100%;
      height: 33px;
      button {
        // width: 20%;
        width: 100%;
        font-size: 0.6em;
        padding: 10px 5px;
        border-left: 0px;
        &.PROCESSING {
          border: 1px solid #333;
        }
        &:first-of-type {
          border: 1px solid #333;
        }
      }
    }
    .orderBox__bottomRez {
      text-align: center;
      padding: 5px 20px;
      border: 1px solid #333;
      border-top: 0;
      background: #000;
      span {
        color: #fff;
        font-weight: 600;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .options {
    width: 100%;
    margin: 0;
    .option {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      margin-left: 20px;
      &::before {
        content: "+";
        position: absolute;
        left: -13px;
        top: -1px;
      }
    }
    .comm {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      margin-left: 20px;
      &::before {
        content: "-";
        position: absolute;
        left: -13px;
        top: -1px;
      }
    }
  }
  .grandTotal {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: rgba(76, 175, 80, 0.1);
    margin-top: 5px;
  }
  .subtotal {
    margin-bottom: 5px;
  }
  .dtt {
    width: 100%;
    border-top: 1px solid #333;
    border-bottom: 1px solid #333;
    margin-top: 5px;
    margin-bottom: 5px;
    padding: 0;
  }
  .subtotal,
  .discount,
  .total_shipping,
  .totals_tip {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // background: rgba(76, 175, 80, 0.1);
    b {
      font-size: 0.8em;
    }
  }
  .width25 {
    width: auto;
  }

  .margin-bot-2 {
    margin-bottom: 2px;
  }
</style>

<style lang="scss">
  html, body {
      height: 100%;
      width: 100%;
      margin: 0;
  }
  .vm--modal {
    width: 90% !important;
    left: 5% !important;
    height: 400px !important;
    @media screen and (max-width: 550px) {
      font-size: 12px;
      height: 430px !important;
    }
  }
  .modalContainer button {
    margin: 0 24px;
    width: calc(100% - 48px);
    border: 0;
  }

  .dynamic-height {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: stretch;
    justify-content: center;
  }
</style>